// extracted by mini-css-extract-plugin
module.exports = {"loading":"Layout_loading__rUhJN","colorLoading":"Layout_colorLoading__YQ5Wk"};